import { Input } from 'antd'
import { clsx } from 'clsx'
import { useFocus } from 'hook/useFocus'
import { useLatestCallback } from 'hook/useLatestCallback'
import { ChangeEvent, CSSProperties } from 'react'
import css from './TextArea.module.scss'

type Props = {
  disabled?: boolean
  error?: boolean
  limit?: number
  mono?: boolean
  onChange?(value: string): void
  onFocus?(focus: boolean): void
  placeholder?: string
  readonly?: boolean
  rows?: number
  style?: CSSProperties
  value: string
}

export function TextArea(props: Props) {
  const { disabled, error, limit, mono, placeholder, readonly, rows = 4, style, value } = props
  const focus = useFocus(props)
  const status = error ? 'error' : undefined
  const classes = clsx(css.area, mono && css.mono)

  const onChange = useLatestCallback((event: ChangeEvent<HTMLTextAreaElement>) => {
    props.onChange?.(event.target.value)
  })

  return <Input.TextArea className={classes} style={style} status={status} value={value}
    placeholder={placeholder} disabled={disabled} readOnly={readonly} rows={rows} maxLength={limit}
    onChange={onChange} onFocus={focus.onFocus} onBlur={focus.onBlur} />
}
